import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ["Mujeres profesionales y exitosas que sienten que su carrera ha 'matado' su vida amorosa.", "Mujeres que están cansadas de ser 'la amiga' o la 'consejera' y quieren ser la mujer deseada.", 'Solteras que sienten que intimidan a los hombres que realmente les gustan.', 'Mujeres que quieren recuperar su poder femenino sin juegos de manipulación baratos.'];
const notFor = ['Mujeres que buscan trucos mágicos para engañar a las personas.', 'Quienes no están dispuestas a soltar el control y la rigidez de su imagen actual.', 'Personas que creen que el lenguaje corporal no tiene impacto en la biología humana.'];
export function WhoIsFor() {
  return <section className="py-24 px-6 bg-dark" data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-173">
          {/* Para Ti Si */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-174">
            <h3 className="font-serif text-2xl md:text-3xl text-cream mb-8 flex items-center gap-3" data-id="element-175">
              <span className="text-gold" data-id="element-176">Para Ti Si...</span>
            </h3>
            <ul className="space-y-6" data-id="element-177">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-178">
                  <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-179" />
                  <span className="font-sans text-cream/80 font-light leading-relaxed" data-id="element-180">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No Es Para Ti Si */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-181">
            <h3 className="font-serif text-2xl md:text-3xl text-cream/60 mb-8 flex items-center gap-3" data-id="element-182">
              <span className="text-wine" data-id="element-183">No Es Para Ti Si...</span>
            </h3>
            <ul className="space-y-6" data-id="element-184">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-185">
                  <XCircle className="w-6 h-6 text-wine flex-shrink-0 mt-0.5" data-id="element-186" />
                  <span className="font-sans text-cream/80 font-light leading-relaxed" data-id="element-187">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}